import React from 'react';
import { Card, CardBody, CardTitle } from '@progress/kendo-react-layout';
import { Button } from '@progress/kendo-react-buttons';
// import BuildIdLogo from "../../../Assets/Build-ID-Transparent 3.png"
import BuildIdLogo from "../../Assets/mybuilderid-empowering.png";

import "./Login.css";

const paymentPlans = [
    {
        id: 1,
        title: "Basic Plan",
        price: "$9.99/month",
        description: "Get started with basic ad visibility. Your ad will be displayed in standard slots with limited exposure.",
        features: [
            "Ad displayed for 7 days",
            "Standard placement on website",
            "No priority in search results",
            "Up to 3 ad revisions"
        ]
    },
    {
        id: 2,
        title: "Premium Plan",
        price: "$19.99/month",
        description: "Boost your visibility with priority placement and extended ad duration.",
        features: [
            "Ad displayed for 14 days",
            "Featured placement on website",
            "Moderate priority in search results",
            "Up to 5 ad revisions",
            "Basic performance analytics"
        ]
    },
    {
        id: 3,
        title: "Pro Plan",
        price: "$39.99/month",
        description: "Maximize exposure with a top-tier ad placement and enhanced analytics.",
        features: [
            "Ad displayed for 30 days",
            "Top placement on website",
            "High priority in search results",
            "Unlimited ad revisions",
            "Advanced performance analytics",
            "Ad highlighted with special badge"
        ]
    }
];

export default function LoginPlanCards({ setActivePage }) {
    return (
        <div
            className='login-wrapper'
            style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                height: '95vh',
                backgroundColor: "#f4f4f4",
                padding: "20px",
                position: "relative"
            }}>
            <div className="background-shapes">
                <div className="shape-1"></div>
                <div className="shape-2"></div>
                <div className="shape-3"></div>
            </div>
            {/* Logo */}
            <div style={{
                position: "absolute",
                top: "10px",
                left: "50%",
                transform: "translateX(-50%)",
                width: "74.6vw",
                background: "white",
                borderRadius: "8px",
                boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
                padding: "8px 18px",
                display: "flex",
            }}>
                <img className="buildid-logo" height="60px" src={BuildIdLogo} alt="Build ID Logo" onClick={() => window.location.href = "https://www.mybuilderid.com"} />
            </div>
            <h2 style={{ margin: "88px 0px 28px 0px", fontSize: "24px", fontWeight: "bold", color: "white" }}>
                Choose Your Advertising Plan
            </h2>

            <div className="login-cards-container-TEMP" style={{ display: "flex", gap: "32px", flexWrap: "wrap", justifyContent: "center" }}>
                {paymentPlans.map(plan => (
                    <Card
                        key={plan.id}
                        className="login-card"
                        style={{
                            minHeight: "350px",
                            borderRadius: "12px",
                            boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                            transition: "transform 0.2s ease-in-out",
                            cursor: "pointer",
                            backgroundColor: "white"
                        }}
                        onMouseEnter={(e) => e.currentTarget.style.transform = "scale(1.05)"}
                        onMouseLeave={(e) => e.currentTarget.style.transform = "scale(1)"}
                        onClick={() => setActivePage("login")}
                    >
                        <CardBody style={{ padding: "20px", textAlign: "center" }}>
                            <CardTitle>
                                <h2 style={{ fontSize: "20px", fontWeight: "bold", color: "#224db3" }}>{plan.title}</h2>
                            </CardTitle>
                            <h3 style={{ fontSize: "18px", color: "#36afb1", margin: "10px 0" }}>{plan.price}</h3>
                            <p style={{ fontSize: "14px", color: "#666", marginBottom: "15px" }}>{plan.description}</p>
                            <ul style={{ listStyleType: "none", padding: 0, textAlign: "left", fontSize: "14px", color: "#444" }}>
                                {plan.features.map((feature, index) => (
                                    <li key={index} style={{ marginBottom: "5px" }}>✅ {feature}</li>
                                ))}
                            </ul>
                        </CardBody>
                    </Card>
                ))}
            </div>

            <div className="k-form-buttons" style={{ marginTop: "28px" }}>
                <Button
                    style={{
                        padding: "10px 40px",
                        fontSize: "16px",
                        fontWeight: "bold",
                        borderRadius: "8px",
                        backgroundColor: "#224db3",
                        color: "white",
                        border: "none",
                        boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                        transition: "background-color 0.3s ease-in-out"
                    }}
                    onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "#0056b3"}
                    onMouseLeave={(e) => e.currentTarget.style.backgroundColor = "#224db3"}
                    onClick={() => setActivePage("login")}
                >
                    Go to Login
                </Button>
            </div>
        </div>
    );
}
